export default "__VITE_ASSET__ndeizJfd__"